import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AllOrdersContextProvider } from "./context/AllOrdersContext";
import { ItemConfigsContextProvider } from "./context/ItemConfigContext";
import { AuthContextProvider } from "./context/AuthContext";
import { OrdersContextProvider } from "./context/OrderContext";
import { AvailableItemConfigsContextProvider } from "./context/AvailableItemConfigContext";
import { LanguageContextProvider } from "./context/LanguageContext";


createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageContextProvider>
        <AvailableItemConfigsContextProvider>
          <OrdersContextProvider>
            <AuthContextProvider>
              <ItemConfigsContextProvider>
                  <AllOrdersContextProvider>
                    <App />
                  </AllOrdersContextProvider>
              </ItemConfigsContextProvider>
            </AuthContextProvider>
          </OrdersContextProvider>
        </AvailableItemConfigsContextProvider>
      </LanguageContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);